<template>
  <div class="block" :style="{
    maxWidth: maxWidth,
    flex: `1 1 ${maxWidth}`,
  }" :class="{
    'block--left': left,
    'block--right': right,
  }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VBlock',

  props: {
    maxWidth: {
      type: String,
      default: '100%',
    },

    left: {
      type: Boolean,
      default: false,
    },

    right: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  margin: 0 auto;

  & > ::v-deep * {
    display: block;
    width: 100%;
    height: auto;
  }

  &--left {
    margin-left: 0;
  }

  &--right {
    margin-right: 0;
  }

  &:not(:first-child) {
    margin-top: calc($gridGutter * 2);
  }
}
</style>
